var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 72,
    viewBox: "0 0 175 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5268 31.7124C22.6163 29.5678 13.3533 31.143 1 37.7541V71.5H174V1C163.142 5.71892 157.566 9.70855 146.196 13.0836C127.836 18.5336 113.978 8.36761 97.2827 17.6149C82.7445 25.6674 86.5382 47.5518 69.994 49.8377C55.2005 51.8817 51.2849 33.9876 36.5268 31.7124Z",
    fill: "url(#paint0_linear_676_1566)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.7541C13.3533 31.143 22.6163 29.5678 36.5268 31.7124C51.2849 33.9876 55.2005 51.8817 69.9941 49.8377C86.5382 47.5518 82.7445 25.6674 97.2827 17.6149C113.978 8.36761 127.836 18.5336 146.196 13.0836C157.566 9.70855 163.142 5.71892 174 1",
    stroke: "#CA6B6E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_1566",
    x1: 88.0058,
    y1: -19,
    x2: 88.0059,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA8184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA6B6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveRed);
export default __webpack_public_path__ + "static/media/wave_red.d44620153398a249b6210268fa344ae7.svg";
export { ForwardRef as ReactComponent };